import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import Inicio from "./Inicio";
import MediaCard from "./MediaCard";

const Main = () => {
  const [datos, setDatos] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  useEffect(() => {
    setLoading(true);
    fetch("https://api.fbi.gov/wanted/v1/list")
      .then((res) => (res.ok ? res.json() : Promise.reject(res)))
      .then((json) => {
        setDatos(json);
        setLoading(false);
        setError(false);
      })
      .catch((err) => {
      setError(err);
      setLoading(false);
      setDatos("")
    });
  }, []);
  return (
    <div style={{ width: "100%", margin: "0" }}>
      <Inicio />
      <h2
        style={{
          fontFamily: "sans-serif",
          color: "white",
          textAlign: "center",
        }}
      >
        LISTA DE PERSONAS BUSCADAS POR EL FBI
      </h2>
      {error && <p style={{color:"white", fontSize:"2rem", textAlign:"center"}}>{`ocurrió un error al solicitar los datos ${error.status} ${error.statusText || "Not Found"}`}</p>}
      {loading && (
        <h2
          style={{
            fontFamily: "sans-serif",
            fontSize: "2rem",
            textAlign: "center",
            color: "white",
          }}
        >
          cargando...
        </h2>
      )}
      <div
        style={{
          width: "100%",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          alignItems: "start",
          gap: "1rem",
        }}
      >
        {datos && datos.items.map((el) => <MediaCard el={el} />)}
      </div>
    </div>
  );
};

export default Main;
